/**
 * Backend API origin (no trailing slash).
 * Set REACT_APP_API_URL at build time to target an environment; the default
 * below only applies to local development.
 *   prod:    https://api.brokeragentbase.com
 *   staging: https://staging-api.brokeragentbase.com
 * axios (`http_common.js`), uploads, proxy-image URLs, and Node SSR servers
 * all read this value.
 */
const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:4000";

const environment = {
  apiUrl,
  /** Full URL for multipart upload endpoint */
  uploadUrl: `${apiUrl}/upload`,
  /** Full URL for asset upload (e.g. logos) */
  uploadAssetUrl: `${apiUrl}/uploadasset`,
};

export default environment;
